export default __webpack_public_path__ + "static/media/onboarding3.bc1e03ab.gif";